// src/reportWebVitals.ts
import { ReportCallback } from 'web-vitals';

interface VitalsMetric {
    name: string;
    delta: number;
    id: string;
    value: number;
}

declare global {
    interface Window {
        gtag?: (
            command: 'event',
            eventName: string,
            eventParams: {
                vitals_name: string;
                vitals_value: number;
                vitals_delta: number;
                vitals_id: string;
                vitals_rating: 'good' | 'needs-improvement' | 'poor' | 'measured';
                non_interaction: boolean;
            }
        ) => void;
    }
}

const reportWebVitals = (onPerfEntry?: ReportCallback): void => {
    if (onPerfEntry && typeof onPerfEntry === 'function') {
        // Standard handler (backward compatibility)
        import('web-vitals').then(({ onCLS, onFCP, onLCP, onTTFB, onINP }) => {
            onCLS(onPerfEntry);
            onFCP(onPerfEntry);
            onLCP(onPerfEntry);
            onTTFB(onPerfEntry);
            onINP(onPerfEntry);
        });
    } else {
        // Default handler for Google Analytics
        import('web-vitals').then(({ onCLS, onFCP, onLCP, onTTFB, onINP }) => {
            const sendToGA4 = ({ name, delta, id, value }: VitalsMetric): void => {
                if (typeof window.gtag === 'function') {
                    window.gtag('event', 'web_vitals', {
                        vitals_name: name,
                        vitals_value: value,
                        vitals_delta: delta,
                        vitals_id: id,
                        vitals_rating: name === 'CLS' ? (value <= 0.1 ? 'good' : (value <= 0.25 ? 'needs-improvement' : 'poor')) :
                            name === 'LCP' ? (value <= 2500 ? 'good' : (value <= 4000 ? 'needs-improvement' : 'poor')) :
                                'measured',
                        non_interaction: true,
                    });
                }
            };

            // Use the GA4 handler for all Core Web Vitals
            onCLS(sendToGA4);
            onFCP(sendToGA4);
            onLCP(sendToGA4);
            onTTFB(sendToGA4);
            onINP(sendToGA4);
        });
    }
};

export default reportWebVitals;
